// extracted by mini-css-extract-plugin
export var cardContainer = "_qz-0";
export var cardHeader = "_qz-2";
export var collapsedState = "_qz-3";
export var dragHandle = "_qz-5";
export var dragHandleIcon = "_qz-6";
export var dragging = "_qz-1";
export var titleArea = "_qz-4";